module.exports = __webpack_public_path__ + "static/audio-f99b3d2b7412dc8b87ac619ff2baf6e2.jpg";